<div leaflet [style.height]="height + 'px'" [leafletOptions]="options" (leafletMapReady)="onMapReady($event)"></div>

<div class="section-spacing">
  <div class="container ss-filter-placeholder">
    <div class="row filter-wrapper">
      <div class="col-6">

      </div>
      <div class="col-6">
        <form>
          <fieldset class="filter-search">
            <legend></legend>
            <svg width="30px" height="30px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 11.1 11.1"
              style="enable-background:new 0 0 11.1 11.1;" xml:space="preserve">
              <style type="text/css">
                .search-icon_1 {
                  fill: #0d2346;
                }

                .search-icon_2 {
                  fill: none;
                  stroke: #0d2346;
                  stroke-miterlimit: 10;
                }
              </style>
              <g>
                <g>
                  <path class="search-icon_1" d="M4.9,1.4c1.9,0,3.5,1.6,3.5,3.5S6.9,8.4,4.9,8.4S1.4,6.9,1.4,4.9S3,1.4,4.9,1.4 M4.9,0.4c-2.5,0-4.5,2-4.5,4.5
                       s2,4.5,4.5,4.5s4.5-2,4.5-4.5S7.4,0.4,4.9,0.4L4.9,0.4z" />
                </g>
                <g>
                  <line class="search-icon_2" x1="7.6" y1="7.6" x2="10.6" y2="10.6" />
                </g>
              </g>
            </svg>
            <input type="text" class="ss-search" placeholder="Search" name="queryValue" [(ngModel)]="queryValue" (ngModelChange)="search()" />
          </fieldset>
        </form>
      </div>
    </div>
  </div>

  <div>
    <ul class="news-list row">
      <li *ngFor="let item of paged" class="col-lg-3 col-md-4 col-sm-6">
        <div class="media-tease">
          <a target="_blank" class="no-loader" href="{{item.url}}">
            <div class="media-tease-content">
              <p class="tease-theme">Sanitary Survey</p>
              <h3>{{ item.pageTitle }}</h3>
              <p class="tease-subtitle">{{ item.localAuthority }}</p>
              <p class="tease-forward-crumb">Download</p>
            </div>
          </a>
        </div>
      </li>
    </ul>
  </div>

  <lib-pagination [page]="page" [pages]="totalpages" (pageChange)="pageChanged($event)"></lib-pagination>
</div>